export const GAMES = "GAMES";
export const DEILD = "DEILD";
export const LID = "LID";
export const UMFERDIR = "UMFERDIR";
export const UMFERD = "UMFERD";
export const PICKEDTEAM = "PICKEDTEAM";
export const GENGILIDA = "GENGILIDA";
export const SELECTEDFLOKKUR = "SELECTEDFLOKKUR";
export const MARKAHAESTU = "MARKAHAESTU";
export const ALLGAMES = "ALLGAMES";